module.exports = "<tr> <td> There are no invoices to display at this time. </td> <td/> <td/> <td/> <td/> <td/> <td/> </tr>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/billingInformation/html/noInvoicesRow.html
// module id = 1245
// module chunks = 1